module.exports = "/assets/ae16eb8a133c9416b8312126900fa9aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SW.png
// module id = 1836
// module chunks = 0